import { ASSETS_ROUTE } from "../../config";
import { AssetModel } from "../../models/data/assets/AssetModel";
import { BaseRepository } from "../baseRepository";


const STANDALONE_ASSETS_ROUTE: string = `${ASSETS_ROUTE}/standalone`;
const DEPENDENT_ASSETS_ROUTE: string = `${ASSETS_ROUTE}/dependent`;

export class AssetsRepository extends BaseRepository {
    public async getDependentAsset(
        assetId: string

    ): Promise<any> {
        const response = await this.api.get(`${DEPENDENT_ASSETS_ROUTE}/${assetId}/content`);
        return response.data;
    }

    public async listDependentAssets(
        pageNumber: number,
        pageSize: number,
        name?: string

    ) : Promise<AssetModel[] | any> {
        const response = await this.api.get(DEPENDENT_ASSETS_ROUTE + "s", {
            params: {
                pageNumber,
                pageSize,
                name
            }
        });
        return response.data;
    }

    public async listStandaloneAssets(
        pageNumber: number,
        pageSize: number,
        name?: string

    ) : Promise<AssetModel[] | any> {
        const response = await this.api.get(STANDALONE_ASSETS_ROUTE + "s", {
            params: {
                pageNumber,
                pageSize,
                name
            }
        });
        return response.data;
    }

    public async uploadDependentAsset(
        files: FileList

    ) : Promise<any> {
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append("files", files[i]);
        }

        const response = await this.api.post(DEPENDENT_ASSETS_ROUTE, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return response.data;
    }

    public async uploadStandaloneAsset(
        files: FileList

    ) : Promise<any> {
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append("files", files[i]);
        }

        const response = await this.api.post(STANDALONE_ASSETS_ROUTE, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return response.data;
    }

    public async deleteDependentAssets(
        assetIds: string[]

    ) : Promise<any> {
        const response = await this.api.delete(DEPENDENT_ASSETS_ROUTE, {
            params: {
                ids: assetIds.join("&ids=")
            }
        });
        return response.data;
    }

    public async deleteStandaloneAssets(
        assetIds: string[]

    ) : Promise<any> {
        const response = await this.api.delete(STANDALONE_ASSETS_ROUTE, {
            params: {
                ids: assetIds.join("&ids=")
            }
        });
        return response.data;
    }
}